import { Card, CardProps } from 'antd';

export const AppCard = ({ style, ...props }: CardProps) => (
  <Card
    {...props}
    style={{
      background: 'white',
      border: '1px solid #e0e0e0',
      boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05), 0 4px 16px rgba(102, 126, 234, 0.12)',
      borderRadius: 15,
      ...style
    }}
  />
);
